import { Stack } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

import { MobileDataGridItemEntryProps } from './MobileDataGridItemEntry.props';
import { StyledTypography } from './MobileDataGridItemEntry.styles';
import { TypographyFontWeightProps, TypographyVariantProps } from '../../atoms/Typography';

export const MobileDataGridItemEntry: React.FC<MobileDataGridItemEntryProps> = ({
  data
}) => {
  return (
    <Stack>
      {data.isValueIcon ? 
        <img width={32} height={32} src={data.value?.toString()} alt={data.title || 'Icon'} />
        :

        (data.isValueLink && data.valueLinkUrl) ?
          <Link to={data.valueLinkUrl}>{data.value}</Link>
          :
          <StyledTypography
            variant={data.valueFontVariant || TypographyVariantProps.Subtitle2}
            fontWeight={data.valueFontWeight || TypographyFontWeightProps.Regular}
          >
            {data.value}
          </StyledTypography>
      }
    </Stack>
  );
};
